<template>
    <div class="card-header" style="height:5em; width: 85%; background: #FCFDFD; position: fixed; top: 0; right: 5px;  z-index: 8000;">
        <div class="card card-header-inner" style="padding-left: 18vw; margin-top: 3px; padding: 0.82em 1em; background:  #ffffff; border-top-right-radius: 18px;">
            <div style="float:left; width:80%;">
                <div style="float: left;">
                    <p v-if="loggedIn">Welcome, {{ user.user_name }}
                        <span v-if="set_app_text_01">,
                            <a v-if="site_user_type == 2" href='/dashboard' style="color: #ff0000; font-size: 13px;">Manage Store | </a>
                            <a href='/search' style="color: #ff0000; font-size: 13px;">Place your Order</a>
                        </span>
                    </p>
                    <p v-else>
                        Welcome. <span><a href='/search' style="color: #ff0000; font-size: 13px;">Place your Order</a></span>
                    </p>
                </div>
                <!-- <div style="float: right; width: 56%;"> -->
                <div style="float: right;">
                   <input type="text" class="form-control" style="border: none; border-bottom: #000000 solid 1px; border-top: solid #ffffff 0px;" placeholder="Search"/>
                </div>
                <div style="clear: both;"></div>
            </div>
            <div style="float:right; width:20%; text-align: left; padding-left: 1em; padding-top: 8px;">
                <span><i class="fas fa-map-marker" style="color: #ff0000;"></i>&nbsp;Location</span>
            </div>
            <div style="clear: both;"></div>
        </div>
    </div>
</template>

<script>
    import services from './../../services/service'; // Service Class
    import AccountResources from './../Account/Resources/commonfunctions.js';

    //
    let service = new services();

    export default {
        name: 'DashboardHeader',
        mixins: [AccountResources],
        data () {
            return {
                loggedIn:false,
                set_app_text_01:true,
                set_app_order:false
            }
        },
    
        components: {},
        methods: {
            preset() {
                this.loading = true;
                //../
                let self = this;
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.loggedIn = true;
                        self.user = value;
                        self.setSiteUser();
                        //self.setPageSettings();
                    }else {
                        self.loading = false;
                        //self.$router.push('/login')
                    }
                });
            },

            setPageSettings(){
                //this.setSiteUser();
                //
                //get route //this.$route.params.id
                let page_path = this.$route.path;
                // if((page_path == "/dashboard") && (this.site_user_type == 2)){
                if(this.site_user_type == 2){
                    this.set_app_order = true;
                    this.set_app_text_01 = false;
                }
            },
        },
        created: function(){
            this.preset();
        }
    }
</script>


// WEBPACK FOOTER //
// Header.vue?d382d6f8